import compose from 'recompose/compose';
import { withAnalytics } from '@carvana/analytics';
import FinanceError from './finance-error';

export default compose(
  withAnalytics({
    componentName: 'FinanceError',
    enableComponentTracking: true
  })
)(FinanceError);
